// extracted by mini-css-extract-plugin
export default {"marginTop":"EditShift_marginTop__06cb5","buttonDiv":"EditShift_buttonDiv__od2vT"};